<template>
  <div class="vertifywrap">
      <div class="vertify">
          <div class="el-icon-close" @click="close"></div>
          <h2>展商认证</h2>
          <div class="vertifymain">
                <div style="margin-bottom:16px;">
                    <p>账号</p>
                    <el-input v-model="username"></el-input>
                </div>
                <div>
                    <p>密码</p>
                    <el-input v-model="password" type="password"></el-input>
                </div>
          </div>
          <p class="vertifytips">请向主办方索取您的企业账号及密码</p>
          <div class="vertifybtn" @click="submit">提交</div>
      </div>
  </div>
</template>

<script>
import { getAttestation } from "@/api/api";
export default {
    name: "mine",
    data() {
        return {
            username: '',
            password: '',
        }
    },
    created() {
    },
    mounted() {
        this.memberid = localStorage.getItem('memberid');
    },
    methods: {
        close(){
            this.$emit('close-vertify', false)
        },
        submit(){
            if(this.username.length == 0){ 
                this.$message('请输入账号');
            }else if(this.password.length == 0){
                this.$message('请输入密码');
            }else{
                this.getVetify();
            }   
        },
        getVetify(){
            let data = this.$qs.stringify({
                memberid: this.memberid,
                username: this.username,
                password: this.password,
            })
            getAttestation(data).then(res=>{
                //console.log(res)
                this.$message(res.data.errmsg);
                if(res.data.errno == 0){
                    this.$emit('close-vertify', false)
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        
    }
}
</script>

<style scoped>
.vertifywrap{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, .3);}
.vertify{padding: 25px 26px 50px;background:#CAC28A;border-radius:17px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);color: #fff;font-size:18px;}
.vertify .el-icon-close{font-size: 40px;cursor: pointer;}
.vertify h2{font-size: 30px;margin:28px 0 38px;}
.vertify h2,.vertifytips{text-align: center;}
.vertifytips{font-size:20px;line-height: 24px;margin-bottom: 58px;margin-top: 10px;}
.vertifymain{width:328px;padding: 0 40px;}
.el-input__inner{height: 40px;line-height: 40px;border-radius: 1px;margin-top: 3px;}
.vertifybtn{width:153px;height:40px;text-align: center;line-height: 40px;border-radius:3px;border:2px solid rgba(255,255,255,1);margin:0 auto;cursor: pointer;font-size:18px;}
</style>